module.exports = __webpack_public_path__ + "static/img/login-banner-open-source.b288a67e.png";